import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  OrderModel,
  IStoreOrdersStateSuccess,
  IStoreOrdersStateError,
  IUpdateStatusOrderPayload,
} from '@boxx/store-core';
import { Store } from '@ngrx/store';
import * as fromReducer from '../store.reducer';
import * as fromOrdersActions from './store-orders.actions';
import * as fromSelectors from './store-orders.selectors';

@Injectable()
export class StoreOrdersStore
  implements
    IStoreBase<OrderModel[], IStoreOrdersStateSuccess, IStoreOrdersStateError>
{
  constructor(public store: Store<fromReducer.IStoreState>) {}

  get loading$() {
    return this.store.select(fromSelectors.getOrdersIsLoading);
  }
  get data$() {
    return this.store.select(fromSelectors.getOrdersData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getOrdersHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getOrdersError);
  }
  get success$() {
    return this.store.select(fromSelectors.getOrdersSuccess);
  }

  fetch = () => this.store.dispatch(fromOrdersActions.loadOrdersBeginAction());

  loadOrderById = (id: number) =>
    this.store.dispatch(fromOrdersActions.loadOrderByIdBeginAction({ id }));

  updateOrder = (payload: IUpdateStatusOrderPayload) =>
    this.store.dispatch(
      fromOrdersActions.updateOrderBeginAction({ payload })
    );
}
